<template>
  <div v-if="producer && !loading">
    <CRow class="align-items-center mb-2">
      <CCol col="auto" class="mt-2 mb-0 my-sm-0">
        <CButton color="outline-primary" size="sm" @click="onBack()">
          <font-awesome-icon icon="arrow-left" />
        </CButton>
      </CCol>
      <CCol sm class="pl-0 d-none d-md-block">
        <span class="text-gray-700"
          >{{ marketName(market) }} / {{ producer.role.name }}</span
        >
      </CCol>
    </CRow>
    <CCard class="bg-white rounded producer-profile-card">
      <MarketProducerProfile
        :producer="producer"
        :market="market.market"
        :closeButton="false"
      />
    </CCard>
  </div>
  <div class="text-center" v-else>
    <CSpinner color="primary" size="lg" />
  </div>
</template>

<script>
import marketMixin from "../../mixins/market";
import MarketProducerProfile from "./partials/MarketProducerProfile.vue";
import { apiGetRQL } from "../../helpers/apiHelper";
import { mapState } from "vuex";

export default {
  name: "UiMarketProducer",

  components: { MarketProducerProfile },

  mixins: [marketMixin],

  data() {
    return {
      loading: true,
      producer: null,
    };
  },

  methods: {
    async fetchProducer() {
      let rqlFilter = {
        producer: {
          style: "query",
          operator: "=",
          term: this.$route.params.producerId,
        },
        limit: {
          style: "query",
          operator: "=",
          term: 1,
        },
      };
      let params = {
        endpoint: "family_market_variants",
        params: [
          this.$store.state.connections.current.family.id,
          this.$route.params.marketId,
        ],
        filter: rqlFilter,
      };

      const response = await apiGetRQL(params);

      if (response && response.data) {
        this.loading = false;
        this.producer =
          response.data.payload.Items[0].ppl.productproducer.producer;
      }
    },

    onBack() {
      this.$router.go(-1);
    },
  },

  computed: {
    ...mapState("shop", ["market", "cart"]),
  },

  mounted() {
    this.fetchProducer();
  },
};
</script>
